import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import { far } from '@fortawesome/free-regular-svg-icons'; // regular icons

// solid icons
import {
  faCheckCircle,
  faTimesCircle,
  faUsers,
  faUserCircle,
  faCalendarAlt,
  faQrcode,
  faCopy,
  faPlus,
  faTrash,
  faBars,
  faPen,
  faSearch,
  faSave,
  faDollarSign,
  faUserTimes,
  faPercentage,
  faInfoCircle,
  faDownload,
  faCheck,
  faPaperPlane,
  faLevelUpAlt,
  faCaretUp,
  faCaretDown,
  faHashtag,
  faAngleDoubleRight,
  faUserPlus,
  faCreditCard,
  faEnvelope,
  faTimes,
  faPlusCircle,
  faUndo,
  faUsersCog,
} from '@fortawesome/free-solid-svg-icons';

// brand icons
import {
  faCcStripe,
} from '@fortawesome/free-brands-svg-icons';

// add icons to library
library.add(
  faCheckCircle,
  faTimesCircle,
  faUsers,
  faUserCircle,
  faCalendarAlt,
  faQrcode,
  faCopy,
  faPlus,
  faTrash,
  faBars,
  faPen,
  faSearch,
  faSave,
  faDollarSign,
  faUserTimes,
  faPercentage,
  faInfoCircle,
  faDownload,
  faCheck,
  faPaperPlane,
  faLevelUpAlt,
  faCaretUp,
  faCaretDown,
  faHashtag,
  faAngleDoubleRight,
  faUserPlus,
  faCreditCard,
  faCcStripe,
  faEnvelope,
  faTimes,
  faPlusCircle,
  faUndo,
  faUsersCog,
);

// use Cue component
Vue.component('font-awesome-icon', FontAwesomeIcon);

export default {
  name: 'icons',
};
